// ServicesSection.jsx
import React, { useState } from "react";
import "./services.mobile.css"; // <-- updated CSS with flip styles
import { Link } from "react-router-dom";


const ServicesSection = () => {
  const services = [
    {
      icon: "bi-house-gear", // alt: bi-house or bi-tools for generic services
      title: "Home & Kitchen Services",
      desc: "Book plumbers, electricians, cleaners, and kitchen help with tracking.",
    },

    // NEW: Quick Drop (Transport)
    {
      icon: "bi-truck", 
      title: "Quick Drop (Transport)",
      desc: "On-demand pick-up & drop for parcels or errands within the city.",
    },
    {
      icon: "bi-shield-lock",
      title: "Security & Visitor Pass",
      desc: "Issue digital entry passes, verify visitors, and track logs.",
    },
    {
      icon: "bi-megaphone",
      title: "Notices & Announcements",
      desc: "Publish society-wide notices with delivery & read receipts.",
    },
    {
      icon: "bi-calendar-event",
      title: "Events & RSVPs",
      desc: "Create events, manage RSVPs and reminders for residents.",
    },
    {
      icon: "bi-file-earmark-check",
      title: "Elections & Voting",
      desc: "Conduct secure society elections with audit trails.",
    },
    {
      icon: "bi-tools",
      title: "Complaints & Work Orders",
      desc: "Residents raise tickets, staff resolve with SLAs & updates.",
    },
    {
      icon: "bi-credit-card",
      title: "Payments & Dues",
      desc: "Collect maintenance and fees with automated invoicing.",
    },
    


  ];

  const [flipped, setFlipped] = useState(() => services.map(() => false));
  const toggleFlip = (i) =>
    setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

  return (
    <section id="services" className="py-5">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary-label">Services</h2>
          <p className="text-muted">
            Everything your gated community needs—managed in one place.
          </p>
        </div>

        {/* --- MOBILE (< md): 2×N flip grid --- */}
        <div className="d-md-none">
          <div className="srv-grid" role="list" aria-label="Services">
            {services.map((s, i) => (
              <button
                key={s.title}
                type="button"
                className={`flip-card ${flipped[i] ? "is-flipped" : ""}`}
                onClick={() => toggleFlip(i)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleFlip(i);
                  }
                }}
                aria-expanded={flipped[i]}
                aria-label={`${s.title} details`}
              >
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div
                    className="flip-card-face flip-card-front"
                    aria-hidden={flipped[i]}
                  >
                    <div className="srv-icon-wrap text-primary-label" aria-hidden="true">
                      <i className={`bi ${s.icon} srv-icon`} />
                    </div>
                    <h5 className="srv-title">{s.title}</h5>
                  </div>

                  {/* BACK */}
                  <div
                    className="flip-card-face flip-card-back"
                    aria-hidden={!flipped[i]}
                  >
                   <div> <h6 className="srv-back-title">{s.title}</h6>
                    <p className="srv-desc text-muted">{s.desc}</p>
                    <span className="hint">Tap to flip back</span>
                    

 <Link
                      to={`/services/book/${s.slug}`}
                      className="btn btn-outline-teal btn-sm ms-3"
                      aria-label={`Book ${s.title}`}
                    >
                      Book Services
                    </Link>
</div>

                  </div>
                  
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* --- DESKTOP/TABLET (>= md): original Bootstrap grid --- */}
        <div className="row g-4 d-none d-md-flex">
          {services.map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-2">
                    <i
                      className={`bi ${s.icon} text-primary-label fs-3 me-2`}
                      aria-hidden="true"
                    ></i>
                    <h5 className="card-title mb-0">{s.title}</h5>
                  </div>
                  <p className="card-text text-muted">{s.desc}</p>
                </div>
<div>
   <Link
                      to={`/services/book/${s.slug}`}
                      className="btn btn-outline-teal btn-sm"
                      aria-label={`Book ${s.title}`}
                    >
                      Book Services
                    </Link>
</div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;